import styles from '../index.scss'
const Part = (props: any) => {
  return (
    <div className={styles["dp-business-commodity--part"]}>
      <div className={styles["dp-business-commodity--part-title"]}>
        {props?.title}
      </div>
      <div className={styles["dp-business-commodity--part-name"]}>
        {props?.value}
        {
          props?.tips && (
            <div className={styles["dp-business-commodity--part-tips"]}>{props?.tips}</div>
          )
        }
      </div>
    </div>
  )
}

export default Part
